<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h3 class="text-h5">{{ t("campaign.view_in_app.title") }}</h3>
      </v-card-title>
      <v-card-text>
        {{ t("campaign.view_in_app.hint") }}
      </v-card-text>
      <v-card-actions>
        <v-btn color="green" @click="listPreview">{{
          t("campaign.view_in_app.btn_list")
        }}</v-btn>
        <v-btn color="primary" @click="detailPreview">{{
          t("campaign.view_in_app.btn_detail")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { loadCampaign } from '@/api/campaign.js'

const props = defineProps({
  campaignIdent: String
})

const { t } = useI18n()
const url = ref('')

const fetchData = async () => {
  const rv = await loadCampaign({ ident: props.campaignIdent })
  url.value = rv.campaign.preview_link
}

const detailPreview = () => {
  window.location = url.value
}

const listPreview = () => {
  window.location =
    url.value.replace(/\/campaigns\//i, '/campaigns?uuid=') + '&preview=1'
}

onMounted(() => {
  fetchData()
})
</script>
